import React, { useState, useEffect } from "react";
import * as Icon from "@phosphor-icons/react";
import styles from "./sidebar.css";
import "./../../../../Styles/site.css";

function Sidebar() {
    const [isOpen, setIsOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const toggleSidebar = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div>
            {isMobile && (
                <button styleName="menu-toggle" onClick={toggleSidebar}>
                    <Icon.List weight="bold" styleName="menu-icon" />
                </button>
            )}

            {/* Sidebar */}
            <div styleName={`sidebar ${isOpen ? "open" : ""}`}>
                <div styleName="brand-name">
                    <Icon.Users weight="duotone" styleName="brand-icon" />PS Portal
                </div>
                <a href="/enrollment/index"><Icon.UserPlus weight="fill" styleName="icon" />Enrollment</a>
                <a href="/schedule/index"><Icon.Calendar weight="fill" styleName="icon" />Schedule</a>
                <a href="/student/index"><Icon.Receipt weight="fill" styleName="icon" />Student Account</a>
                <a href="/grading/index"><Icon.Exam weight="fill" styleName="icon" />Grading</a>
            </div>
        </div>
    );
}

export default Sidebar;
